import Image from 'next/image';
import logomark from './logomark@q90.jpg';
import glowAvif from './hero-glow@q25r.avif';
import glowPng from './hero-glow@tiny.png';

export function PricingHero() {
  return (
    <header className="relative mt-[80px] px-4 pb-16 pt-40 [@media(min-width:1160px)]:mt-0">
      <picture>
        <source srcSet={glowAvif.src} type="image/avif" />
        <source srcSet={glowPng.src} type="image/png" />
        <Image
          src={glowAvif}
          alt=""
          priority
          unoptimized
          className="pointer-events-none absolute -top-7 left-1/2 z-20 ml-[-51.375rem] mt-[-22.375rem] max-w-none mix-blend-overlay"
        />
      </picture>
      <Image
        src={logomark}
        alt=""
        priority
        unoptimized
        className="pointer-events-none absolute -top-7 left-1/2 ml-[-15.625rem] w-[31.25rem] max-w-none"
      />
      <div className="relative z-10 mx-auto max-w-2xl space-y-4">
        <h1 className="text-center text-[2.5rem] font-bold leading-none tracking-[-0.035em] text-primary md:text-[3.5rem] lg:text-[4rem]/[4.5rem]">
          Pricing that scales with you
        </h1>
        <span className="block text-center text-[1.125rem] leading-7 text-secondary">
          10,000 monthly active users free. <br />
          Surprisingly simple, exceptionally powerful. <br />
          Every feature you need now and as you scale.
        </span>
      </div>
    </header>
  );
}
